
import { ChevronLeft, ChevronRight } from "lucide-react";
import { PaginationBarWrapper, PaginationControls, PageButton } from "./styles.paginationBar";

export default function PaginationBar({ page, hasNextPage, onPageChange }) {
  return (
    <PaginationBarWrapper>
      <PaginationControls>
        {page > 1 && (
          <PageButton onClick={() => onPageChange(page - 1)}>
            <ChevronLeft size={16} />
          </PageButton>
        )}
        <PageButton $active>{page}</PageButton>
        {hasNextPage && (
          <PageButton onClick={() => onPageChange(page + 1)}>
            <ChevronRight size={16} />
          </PageButton>
        )}
      </PaginationControls>
    </PaginationBarWrapper>
  );
}
